import React from 'react';
import { Button } from '@applyboard/ui-components';
var FourOOne = function FourOOne() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", null, "ERROR 401"), /*#__PURE__*/React.createElement("h1", null, "Access Denied"), /*#__PURE__*/React.createElement("p", null, "You are not authorized to access this page."), /*#__PURE__*/React.createElement(Button, {
    variant: "outlined",
    href: "/login"
  }, "\u2190 Back to Log In"));
};
export default FourOOne;